import { useCallback } from 'react';

import { safeParse } from 'src/app/pages/startAPetition/shared/utils';
import { useLocalStorageValue } from 'src/app/shared/hooks/storage';

import type { SerializedStepState } from '../../types';

import { useResetLegacyStepMedia } from './useResetLegacyStepMedia';

type UseStepStorageReturn = [SerializedStepState | undefined, (stepState: SerializedStepState | null) => void];

// TODO: add some encoding/compression to help reduce size?
export function useStepStorage(): UseStepStorageReturn {
	const [stepStateStorageStr, setStepStateStorageStr] = useLocalStorageValue('step-state', { readOnce: true });
	const parsedStepState = safeParse<SerializedStepState>(stepStateStorageStr);

	const setStepStateStorage = useCallback(
		(stepState: SerializedStepState | null) => {
			const value = stepState ? JSON.stringify(stepState) : null;
			setStepStateStorageStr(value);
		},
		[setStepStateStorageStr],
	);

	const resetStepMedia = useResetLegacyStepMedia();

	const transformStepState = resetStepMedia(parsedStepState);

	return [transformStepState, setStepStateStorage];
}
